import { Injectable, Injector } from '@angular/core';
import { PersonProductQueries, ProductInterface, ProductQueries, UnlockedFreePracticeQueries } from '@campus/dal';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BooksTileComponentInterface } from '../../components';
import { BooksTileService, BooksTileServiceConfigInterface } from './books-tile.service';

@Injectable()
export class PolpoBooksTileService extends BooksTileService {
  constructor(protected injector: Injector) {
    super(injector);
    this.store = injector.get(Store);
  }

  public getBookTiles$(
    sourceFilter?: (data: ProductInterface) => boolean,
    config: BooksTileServiceConfigInterface<ProductInterface> = {}
  ): Observable<BooksTileComponentInterface[]> {
    return combineLatest([
      this.store.select(PersonProductQueries.getProductsWithMethod),
      this.store.select(ProductQueries.getBooksByProduct),
      config.filterUnlockedBooks ? this.store.select(UnlockedFreePracticeQueries.getGroupedByEduContentBookId) : of({}),
    ]).pipe(
      map(([products, booksByProductId, ufpByBookIdDict]) => {
        const filteredProducts = sourceFilter ? products.filter(sourceFilter) : products;

        let booksTiles = filteredProducts.map((product) => {
          let booksForProduct = booksByProductId[product.id] || [];

          if (config.filterUnlockedBooks) {
            booksForProduct = booksForProduct.filter((book) => !!ufpByBookIdDict[book.id]);
          }

          if (config.rowFilter) {
            booksForProduct = booksForProduct.filter((book) => config.rowFilter(book, product));
          }

          const tileTitle = config.titleFn ? config.titleFn(product) : product.description;

          const hasActions = config.actionHandler && config.allowedActions?.length > 0;
          let tile = hasActions
            ? this.mapToBooksTileWithActions(
                product.id,
                tileTitle,
                product.method,
                booksForProduct,
                config.actionHandler,
                config.allowedActions,
                config.favoriteBooks,
                product
              )
            : this.mapToBooksTileWithoutActions(product.id, tileTitle, product.method, booksForProduct, product);

          if (config.rowSortComparer) {
            tile.rows.sort(config.rowSortComparer);
          }

          if (config.tileMapFn) {
            tile = config.tileMapFn(tile, product, booksForProduct);
          }

          return tile;
        });

        if (config.filterEmptyTiles) {
          booksTiles = booksTiles.filter((tile) => !!tile.rows.length);
        }

        if (config.tileFilter) {
          booksTiles = booksTiles.filter(config.tileFilter);
        }

        if (config.tileSortComparer) {
          booksTiles.sort(config.tileSortComparer);
        }

        return booksTiles;
      })
    );
  }
}
